import React, { useState } from 'react'
import { ReactComponent as MoreIcon } from '../assets/icons/more_icon.svg'

const ImageComponent = ({ addImageOnCanvas, item, handleDelete }) => {
    const [showOption, setShowOption] = useState(false)

    return (
        <div
            className='single-image-preview'
            draggable={false}
            onMouseLeave={() => setShowOption(false)}
        >
            <img
                onClick={() => addImageOnCanvas(item)}
                src={item.docUrl}
                alt='img'
            />
            <div className='more-option'>
                <span
                    className='more-icon'
                    onClick={() => setShowOption(!showOption)}
                >
                    <MoreIcon />
                </span>
                <div className={`more-dropdown ${showOption ? 'show' : ''}`}>
                    <p className='option' onClick={() => handleDelete(item)}>
                        Delete
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ImageComponent
